import React from "react";
import { useNavigate } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { ArrowRight } from "@phosphor-icons/react";

export const ContactCTA = () => {
  const navigate = useNavigate();
  return (
    <section id="contact" data-testid="cta-section" className="py-28 md:py-40 bg-navy relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-gold mb-8">Let's Talk</p>
          <h2 className="font-heading font-light text-4xl sm:text-6xl lg:text-7xl text-[#F6F4F0] leading-[1.05] max-w-4xl mx-auto">
            Ready to build something<br />
            <span className="italic text-gold">worth following?</span>
          </h2>
          <p className="text-[#E5E7EB] font-light mt-8 max-w-xl mx-auto leading-relaxed">
            Book a consultation and we'll design a custom plan for your brand. In-person content shoots are scheduled after we meet.
          </p>
          <button
            data-testid="cta-consultation-btn"
            onClick={() => navigate("/consultation")}
            className="group inline-flex items-center gap-3 mt-12 text-xs uppercase tracking-[0.2em] px-10 py-5 bg-[#C8A96A] text-[#0D1B2A] hover:bg-[#F6F4F0] transition-colors duration-300 font-medium"
          >
            Book Your Consultation
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </button>
        </Reveal>
      </div>
    </section>
  );
};
